/**
 * A module representing pubsub.
 * @module pubsub
 * @exports PubSub
 * @see PubSub
 * @example
 * var PubSub = require('pubsub');
 *
 * var subscription = PubSub.subscribe('topic-name', function(prop) {
 *   // Do something now that the event has occurred
 *   // different properties passed
 * });
 *
 * PubSub.publish('topic-name', {
 *   entityID: '00000-00000' // any argument
 * });
 *
 * // ...sometime later where I no longer want subscription...
 * subscription.remove();
 *
 *
 * var custom = PubSub.subscribe('page-load-complete', function(prop) {
 *   // Do something now that the event has occurred
 *   // different properties passed
 *
 *     custom.remove();
 * });
 *
 *
 * //  PubSub.subscribe('navigate-to', function(prop) {
 * //      // prop.ID
 * //      // prop.targetID
 * //      console.log('prop %o', prop);
 * //  });
 *
 * //  PubSub.subscribe('transition-out-init', function(prop) {
 * //      console.log('prop %o', prop);
 * //  });
 *
 * //  PubSub.subscribe('transition-out-complete', function(prop) {
 * //      console.log('prop %o', prop);
 * //  });
 *
 * //  PubSub.subscribe('page-load-init', function(prop) {
 * //      // prop.entity
 * //      // prop.state (training state: 'init', 'reload', 'reset', '')
 * //      console.log('prop %o', prop);
 * //  });
 *
 * //  PubSub.subscribe('page-load-complete', function(prop) {
 * //      // prop.entity
 * //      // prop.state (training state: 'init', 'reload', 'reset', '')
 * //      console.log('prop %o', prop);
 * //  });
 *
 * //  PubSub.subscribe('transition-in-init', function(prop) {
 * //      console.log('prop %o', prop);
 * //  });
 *
 * //  PubSub.subscribe('transition-in-complete', function(prop) {
 * //      console.log('prop %o', prop);
 * //  });
 *
 * //  PubSub.subscribe('interaction-complete', function(prop) {
 * //      // prop.entity
 * //      console.log('prop %o', prop);
 * //  });
 * //
 * //  PubSub.subscribe('task-answered', function(prop) {
 * //      // prop.entity
 * //      // prop.progress (returns current Quiz if it is)
 * //      console.log('prop %o', prop);
 * //  });
 */

define('pubsub',[],function() {
    'use strict';

    var topics = {},
        hOP = topics.hasOwnProperty;

    /**
     * A simple PubSub for publishing and subscribing to notifications by name.
     * @constructor
     * @alias PubSub
     */
    var PubSub = {}

    /**
     * Subscribe for notifications for a given topic.
     * @param {String} topic - The name of the event you want to be notified about.
     * @param {String} listener - Function to call when the specified event happens.
     * @return {Function} remove - Function to remove a topic
     */
    PubSub.subscribe = function(topic, listener) {
        // Create the topic's object if not yet created
        if (!hOP.call(topics, topic)) {
            topics[topic] = [];
        }

        // Add the listener to queue
        var index = topics[topic].push(listener) -1;

        // Provide handle back for removal of topic
        return {
            remove: function() {
                delete topics[topic][index];
            }
        };
    };

    /**
     * Publish an event by name. Listeners previously added by calling subscribe()
     * @param {String} topic - The event name to notify subscribers about.
     * @param {Object} info - The data to pass to the subscriber callbacks.
     */
    PubSub.publish = function(topic, info) {
        // If the topic doesn't exist, or there's no listeners in queue, just leave
        if (!hOP.call(topics, topic)) {
            return;
        }

        // Cycle through topics queue, fire!
        topics[topic].forEach(function(item) {
            item(info != undefined ? info : {});
        });
    };

    /**
     * Returns all topics.
     * @return {Object}
     */
    PubSub.topics = function() {
        return topics;
    };

    window.PubSub = PubSub;

    return PubSub;
});

